export const TIME_CLOCK_MODAL_SLICE = 'timeClockModal';
